import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import ThemeToggle from './ThemeToggle'
import Logo from "./Logo"



const Header = ({siteTitle}) => {
    return (
        <>
            <div className="fixed top-0 z-10 w-full">
                <div className="container flex items-center justify-between h-16 px-2 mx-auto transition-colors duration-500 bg-BaseLight dark:bg-BaseDark">
                    <Logo/>
                    <div className="flex items-center md:space-x-8 dark:text-gray-400">

                        <Link to="/blog">
                            <div className="px-2 py-1 border rounded-md dark:border-Darker dark:bg-BaseDarkHighlight dark-hover:border-teal-400">
                                <span className="text-sm">Blog</span>
                            </div>
                        </Link>
                        <Link to="/about">
                            <div className="px-2 py-1 border rounded-md dark:border-Darker dark:bg-BaseDarkHighlight dark-hover:border-teal-400">
                                <span className="text-sm">About Me</span>
                            </div>
                        </Link>

                        <ThemeToggle/>
                    </div>
                </div>
            </div>

            {/* <div className="absolute top-0 left-0 z-10 w-screen h-screen bg-React">
                <button className="absolute top-0 right-0 mt-4 mr-8"><span className="text-2xl font-bold text-black">x</span></button>
                <div className="flex items-center justify-center">
                    <div>x</div>
                </div>
            </div> */}
        </>
    )
}


Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
